<!-- <div style="width:214px;display: inline-block">
    <color-shade-picker
      [color]="primaryColor"
      (onChangeComplete)="changeComplete($event)"
      (onChange)="changeComplete($event)"
      width="214"
    ></color-shade-picker>
  </div> -->
<div class="input-cell">
    <div class="input-wrapper-row">
        <nb-radio-group [(value)]="selectedOption" (valueChange)="onChangeOption($event)" #optionPicker>
            <nb-radio value="preset">Presets</nb-radio>
            <nb-radio value="custom">Custom</nb-radio>
        </nb-radio-group>
    </div>
    <div class="selected-color-picker">
        <color-sketch [presetColors] ="basicColors" [color]="primaryColor" (onChangeComplete)="handleChangeComplete($event)" (onChange)="handleColorPick($event)" #primaryColorPicker kveToggleSection></color-sketch>
    </div>
</div>
